import React, { useState, useRef, useEffect } from "react";
import { Bar, Line } from "react-chartjs-2";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, LineElement, Title, Tooltip, Legend, PointElement, Filler } from "chart.js";

// Register necessary chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  PointElement,
  Filler
);

function BookingChart() {
  const [chartType, setChartType] = useState("bar"); // State to toggle between chart types
  const chartRef = useRef(null); // Ref to store chart instance

  // Generate dummy data for the last 15 days
  const labels = Array.from({ length: 15 }, (_, i) => {
    const date = new Date();
    date.setDate(date.getDate() - (14 - i));
    return date.toISOString().split("T")[0]; // Format as YYYY-MM-DD
  });

  // Dummy data: Cash tickets booked for flights
  const cashBookings = Array.from({ length: 15 }, () => Math.floor(Math.random() * 50) + 10); // Random values between 10-60

  const data = {
    labels,
    datasets: [
      {
        label: "Cash Tickets Booking",
        data: cashBookings,
        backgroundColor: chartType === "bar" ? "#f54f5f" : "#27d095",  
        borderColor: "#f54f5f",
        borderWidth: 2,
        hoverBackgroundColor: "#f54f5f", 
        hoverBorderColor: "#f54f5f",
        borderRadius: 5,  
        fill: chartType === "line", 
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
        labels: {
          font: {
            family: "Arial, sans-serif",
            size: 14,
            weight: "bold",
            color: "#333", // Legend text color
          },
        },
      },
      title: {
        display: false,
        text: "Cash Tickets Booking for Flights (Last 15 Days)",
        font: {
          family: "Arial, sans-serif",
          size: 18,
          weight: "bold",
          color: "#333",
        },
        padding: {
          bottom: 20,
        },
      },
      tooltip: {
        enabled: true,
        backgroundColor: "rgba(0, 0, 0, 0.7)", // Tooltip background color
        titleColor: "#fff", // Tooltip title color
        bodyColor: "#fff", // Tooltip body color
        footerColor: "#fff", // Tooltip footer color
        cornerRadius: 5, // Tooltip rounded corners
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          stepSize: 10, // Y-axis tick step size
          font: {
            family: "Arial, sans-serif",
            size: 12,
            weight: "bold",
            color: "#333", // Y-axis ticks color
          },
        },
        grid: {
          color: "#ddd", // Light gridlines
          borderColor: "#ddd", // Gridline border color
          borderWidth: 1, // Gridline width
        },
      },
      x: {
        ticks: {
          font: {
            family: "Arial, sans-serif",
            size: 12,
            weight: "bold",
            color: "#333", // X-axis ticks color
          },
        },
        grid: {
          color: "#ddd", // Light gridlines
          borderColor: "#ddd", // Gridline border color
          borderWidth: 1, // Gridline width
        },
      },
    },
    interaction: {
      mode: "index", // Set interaction mode for better hover effects
      intersect: false, // Allow hover effect even if the pointer doesn't intersect with the bar
    },
    elements: {
      bar: {
        borderRadius: 8, // Slight rounding for the bar corners
        borderSkipped: "bottom", // Only skip border on the bottom of the bars
      },
    },
  };

  // Effect to destroy the previous chart when component unmounts
  useEffect(() => {
    return () => {
      if (chartRef.current && chartRef.current.chart) {
        chartRef.current.chart.destroy();
      }
    };
  }, []);

  const handleChartToggle = () => {
    setChartType((prev) => (prev === "bar" ? "line" : "bar"));
  };

  return (
    <div className="booking-chart-container">

        <div className="d-flex justify-content-between align-items-center pt-2">
        <div><h2 className="chart-title text-start">Booking Stats</h2></div>
        <div>
        <button onClick={handleChartToggle} className="toggle-chart-btn">
        Switch to {chartType === "bar" ? "Line Chart" : "Bar Chart"}
      </button>
        </div>
        </div>
      
      
      <div className="chart-box">
        {chartType === "bar" ? (
          <Bar ref={chartRef} data={data} options={options} />
        ) : (
          <Line ref={chartRef} data={data} options={options} />
        )}
      </div>
    </div>
  );
}

export default BookingChart;
